import CONFIG from '../../config';

export const isReactDesktopPage = (fullUrl: string): boolean => {
  const isRorPage = CONFIG.desktopRoRPages.some((path: string) =>
    fullUrl.startsWith(path)
  );
  return !isRorPage;
};
